(function (window, document) {
  "use strict";

  var CALENDLY_ORIGIN_SUFFIX = "calendly.com";
  var CALCOM_ORIGIN_SUFFIXES = ["cal.com", "cal.dev"];

  function originMatches(origin, suffix) {
    if (!origin) return false;
    var host;
    try {
      host = new URL(origin).host.toLowerCase();
    } catch (e) {
      return false;
    }
    return host === suffix || host.endsWith("." + suffix);
  }

  function isCalendlyOrigin(origin) {
    return originMatches(origin, CALENDLY_ORIGIN_SUFFIX);
  }

  function isCalcomOrigin(origin) {
    for (var i = 0; i < CALCOM_ORIGIN_SUFFIXES.length; i++) {
      if (originMatches(origin, CALCOM_ORIGIN_SUFFIXES[i])) return true;
    }
    return false;
  }

  function calendlyClaimValue(data) {
    var payload = data && data.payload;
    var uri = payload && payload.invitee && payload.invitee.uri;
    if (typeof uri !== "string" || !uri) return null;

    var segments = uri.split("/").filter(Boolean);
    var uid = segments.length ? segments[segments.length - 1] : null;
    return uid ? "calendly_" + uid : null;
  }

  function calcomClaimValue(data) {
    var payload = (data && (data.data || data.payload)) || {};
    var booking = payload.booking || payload;
    var uid = booking && booking.uid;
    if (typeof uid !== "string" || !uid) return null;
    return "calcom_" + uid;
  }

  function postClaim(publicApiBase, body) {
    try {
      var url = publicApiBase.replace(/\/+$/, "") + "/claims";
      var payload = JSON.stringify(body);

      if (window.fetch) {
        window
          .fetch(url, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: payload,
            keepalive: true,
          })
          .catch(function () {});
        return;
      }

      var xhr = new XMLHttpRequest();
      xhr.open("POST", url, true);
      xhr.setRequestHeader("Content-Type", "application/json");
      xhr.send(payload);
    } catch (e) {}
  }

  function armProviderClaimListener(config) {
    if (window._MVT_CLAIM_LISTENER_SET) return;
    if (!window.addEventListener) return;

    var publicApiBase = config && config.publicApiBase;
    var projectKey = config && config.projectKey;
    if (!publicApiBase || !projectKey) return;

    window._MVT_CLAIM_LISTENER_SET = true;

    window.addEventListener(
      "message",
      function (event) {
        var data = event && event.data;
        if (!data || typeof data !== "object") return;

        var claimValue = null;
        var embedKind = null;

        if (isCalendlyOrigin(event.origin) && data.event === "calendly.event_scheduled") {
          claimValue = calendlyClaimValue(data);
          embedKind = "calendly";
        } else if (isCalcomOrigin(event.origin)) {
          var type = data.type || data.action;
          if (type === "bookingSuccessfulV2" || type === "bookingSuccessful") {
            claimValue = calcomClaimValue(data);
            embedKind = "calcom";
          }
        }

        if (!claimValue) return;

        var context = window.MVTContext || {};
        var utils = window.MVTUtils;

        if (utils && utils.consentBlocked && utils.consentBlocked()) return;

        var visitorId =
          utils && utils.getOrCreateVisitorId ? utils.getOrCreateVisitorId(projectKey) : null;
        if (!visitorId) return;

        postClaim(publicApiBase, {
          projectId: projectKey,
          keyKind: "provider_record",
          keyValue: claimValue,
          visitorId: visitorId,
          campaignId: context.campaignId || undefined,
          variantId: context.variantId || undefined,
          embedKind: embedKind,
          framed: window.top !== window.self,
          consentGranted: true,
        });
      },
      false,
    );
  }

  function mintTicket(projectKey) {
    var storeKey = "__mvt_ticket_v1__::" + projectKey;
    try {
      var existing = window.sessionStorage && window.sessionStorage.getItem(storeKey);
      if (existing) return existing;
    } catch (e) {}

    var rand = "";
    var alphabet = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    if (window.crypto && window.crypto.getRandomValues) {
      var buf = new Uint8Array(22);
      window.crypto.getRandomValues(buf);
      for (var i = 0; i < buf.length; i++) rand += alphabet[buf[i] % alphabet.length];
    } else {
      for (var j = 0; j < 22; j++) rand += alphabet[Math.floor(Math.random() * alphabet.length)];
    }
    var ticket = "mvtt_" + rand;

    try {
      if (window.sessionStorage) window.sessionStorage.setItem(storeKey, ticket);
    } catch (e) {}
    return ticket;
  }

  function ensureTicket(config) {
    var publicApiBase = config && config.publicApiBase;
    var projectKey = config && config.projectKey;
    if (!publicApiBase || !projectKey) return null;

    var utils = window.MVTUtils;
    if (utils && utils.consentBlocked && utils.consentBlocked()) return null;

    var visitorId =
      utils && utils.getOrCreateVisitorId ? utils.getOrCreateVisitorId(projectKey) : null;
    if (!visitorId) return null;

    var ticket = mintTicket(projectKey);

    if (!window._MVT_TICKET_REGISTERED) {
      window._MVT_TICKET_REGISTERED = true;
      var context = window.MVTContext || {};
      postClaim(publicApiBase, {
        projectId: projectKey,
        keyKind: "ticket",
        keyValue: ticket,
        visitorId: visitorId,
        campaignId: context.campaignId || undefined,
        variantId: context.variantId || undefined,
        framed: window.top !== window.self,
        consentGranted: true,
      });
    }
    return ticket;
  }

  window.MVTClaims = {
    armProviderClaimListener: armProviderClaimListener,
    mintTicket: mintTicket,
    ensureTicket: ensureTicket,

    calendlyClaimValue: calendlyClaimValue,
    calcomClaimValue: calcomClaimValue,
    isCalendlyOrigin: isCalendlyOrigin,
    isCalcomOrigin: isCalcomOrigin,
  };
})(window, document);
